<template>
  <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Mitarbeiter zuweisen</span>
      </v-card-title>
      <v-sheet class="pa-4">
        <v-text-field
            label="Suchen"
            v-model="search"
            flat
            hide-details
            clearable
            outlined
            clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>
      <v-card-text>
        <v-treeview
            :items="bhStructure"
            :open.sync="open"
            v-model="selected"
            @input="input"
            selectable
            :selection-type="selectionType"
            selected-color="green"
            item-text="text"
            :search="search"
            :filter="filter"
            open-on-click
        >
          <template v-slot:prepend="{ item }">
            <v-icon
                v-if="item.node_type !== 'user'"
                v-text="`mdi-${item.node_type === 'migr' ? 'account-multiple' : 'briefcase-variant'}`"
            ></v-icon>
          </template>
        </v-treeview>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: "assign_user_dialog",
  props: {
    bhStructure: {
      type: Array,
      default: () => [],
    },
    preSelected: {
      type: Array,
      default: () => [],
    },
    singleSelect: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      showDialog: false,
      error: false,
      open: [],
      search: null,
      selected:[],
      prevSelected: [],
    }
  },
  computed: {
    canSubmit() {
      return true;
    },
    filter () {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
    selectionType() {
      return this.singleSelect ? 'independent' : 'leaf';
    }
  },
  watch: {

  },
  methods: {
    show() {
      if (this.showDialog) {
        return;
      }
      this.selected = [...this.preSelected];
      this.prevSelected = [...this.preSelected];
      this.showDialog = true;
    },
    submit() {
      this.$emit('submit', this.selected);
      this.showDialog = false;
    },
    input(sel) {
      if (this.singleSelect) {
        if (sel.length > 1) {
          let newEl = sel.filter(el => !this.prevSelected.includes(el));
          this.prevSelected = [...newEl];
          this.selected = [...newEl];
        } else {
          this.prevSelected = [...sel];
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
